<template>
  <div class="container">

    <v-card>
      <v-card-title class="blue accent-1 gray--text">Bins dados de baja</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="green"
                  dark
                  right
                 @click="upload = !upload"
                  v-on="on"
                >
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Carga masiva de bins dados de baja</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Escriba para filtrar bins"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
            
    <v-data-table 
      :headers="binsListHeaders"
      :items="binsListBody"
      class="elevation-3 mt-5"
      :search="search"
      no-data-text="No hay bins"
    >
      <template v-slot:[`item.purchase_date`]="{item}">
        {{ formatDate(item.purchase_date) }}
      </template>
      <template v-slot:[`item.actions`]="{item}">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              @click="activateBin(item)"
              v-on="on"
            >
            mdi-check
            </v-icon>
          </template>
          <span>Activar Bin</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              @click="deleteBin(item)"
              v-on="on"
            >
            mdi-delete
            </v-icon>
          </template>
          <span>Borrar Bin</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Modal upload -->
    <v-dialog
      v-model="upload"
      width="600px"
    >
      <v-card>
        <v-card-title class="green darken-1">
          Subir archivo de bins
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="upload = false"
          >Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="uploadBins"
          >Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      snackbar: false,
      color: 'green',
      validation_message: '',
      search: null,
      file: null,
      dialog: false,
      upload: false,
      companies: [],
      colors: [],
      sizes: [],
      binIndex: -1,
      bin: {
        id: 0,
        code: '',
        number: '',
        color: null,
        size: null,
        company: null,
        waybill: '',
        purchase_date: new Date().toISOString().substr(0, 10),
      },
      binsListHeaders: [
        {
            text: 'Numero',
            align: 'center',
            sortable: true,
            value: 'number',
            class: "salmon black--text elevation-1 elevation-3"
        },
        {
            text: 'Propietario',
            align: 'center',
            sortable: true,
            value: 'company.name',
            class: "salmon black--text elevation-1 elevation-3"
        },
        {
            text: 'Color',
            align: 'center',
            sortable: true,
            value: 'color.name',
            class: "salmon black--text elevation-1 elevation-3"
        },
        {
            text: 'Tamaño',
            align: 'center',
            sortable: true,
            value: 'size.name',
            class: "salmon black--text elevation-1 elevation-3"
        },
        {
            text: 'Codigo',
            align: 'center',
            sortable: true,
            value: 'code',
            class: "salmon black--text elevation-1 elevation-3"
        },
        {
            text: 'Guia Despacho',
            align: 'center',
            sortable: true,
            value: 'waybill',
            class: "salmon black--text elevation-1 elevation-3"
        },
        {
            text: 'Fecha Compra',
            align: 'center',
            sortable: true,
            value: 'purchase_date',
            class: "salmon black--text elevation-1 elevation-3"
        },
        {
            text: 'Acciones',
            align: 'center',
            sortable: false,
            value: 'actions',
            class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      binsListBody: [],
    }),
    mounted() {
      this.loadColors();
      this.loadSizes();
      this.loadCompanies();
      this.loadBins();
    },
    methods:{
      async loadCompanies(){
        let url = `${this.base_url}companies`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.companies = response.data.data;
        }).catch((error)=>{
          console.log(error);
        });
      },
      async loadColors(){
        let url = `${this.base_url}colors`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.colors = response.data.data;
        }).catch((error)=>{
          console.log(error);
        });
      },
      async loadSizes(){
        let url = `${this.base_url}sizes`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.sizes = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadBins(){
        this.mostrarLoading('Cargando bins dados de baja...');
        let url = `${this.base_url}bins/unsubscribed/all`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.binsListBody = response.data.data;
          this.ocultarLoading();
        }).catch((error)=>{
          console.log(error);
          this.ocultarLoading();
        });
      },
      activateBin(item) {
        this.$confirm('Desea activar este bin?').then(res => {
          if(res){
            let url = `${this.base_url}bins/active/${item.id}`;
            this.axios.put(url, {active: 0}, this.headers).then((response)=>{
              console.log(response);
              const index = this.binsListBody.indexOf(item);
              this.binsListBody.splice(index, 1);
            }).catch((error)=>{
              console.log(error);
            });
          }
        });
      },
      deleteBin(item) {
        this.$confirm('Desea borrar este bin?').then(res => {
          if(res){
            let url = `${this.base_url}bins/${item.id}`;
            this.axios.delete(url, this.headers).then((response)=>{
              console.log(response);
              const index = this.binsListBody.indexOf(item);
              this.binsListBody.splice(index, 1);
            }).catch((error)=>{
                console.log(error);
            });
          }
        });
      },
      async uploadBins(){
        if(!this.file){
          this.validation_message = "Elija un archivo de tipo Excel";
          this.showSnackBar(true);
          return;
        }
        this.headers.headers['Content-Type'] = "multipart/form-data";
        let url = `${this.base_url}bins/upload/unsubscribed`;
        let formData = new FormData();
        formData.append("excel", this.file);
        await this.axios.post(url, formData, this.headers).then((response)=>{
          console.log(response.data.data);
          this.file = null;
          this.upload = false;
          this.loadBins();
          this.showSnackBar(false);
        }).catch((error)=>{
          console.log(error);
          this.validation_message = "Error al subir archivo";
          this.showSnackBar(true);
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers']),
      setCode: function(){
        let company = this.bin.company == null ? '': this.bin.company.short_name;
        let color = this.bin.color == null ? '': this.bin.color.name;
        let size = this.bin.size == null ? '': this.bin.size.name;
        return company + ' ' + color + ' ' + size + ' #' + this.bin.number;
      }
    },
    components:{
    }
  }
</script>
